module.exports = "/_next/static/images/game-1-intro-tutorial-phone-bd6b3f9c2e7596da11bcbf3869a0757b.png";